
import { defineComponent, PropType } from 'vue'
import type { V2PlanConfig } from './v2PlanConfig'

export default defineComponent({
  name: 'V2EnterprisePlanCard',
  props: {
    config: {
      type: Object as PropType<V2PlanConfig>,
      required: true
    }
  }
})
